import { createApiHook } from '../hooks';
import { pixelTesterApiFactory } from './pixelTesterApiFactory';

export const usePixelTesterApi = createApiHook(pixelTesterApiFactory);
